
import { Component, Vue } from "vue-property-decorator";
import { profileApi } from "../../services/api/profile/profile";
import PanamaLayout from "../../layouts/PanamaLayout.vue";
import PhonePrefix from "../../components/PhonePrefix.vue";
import { Variables } from "../../../variables";
import { ProfileQuery } from "../../services/api/models/ProfileQuery.model";
import { VaccinationProfileQuery } from "../../services/api/models/VaccinationProfileQuery.model";

const ProfileProps = Vue.extend({
  props: {
    subject: String,
  },
});

@Component({
  components: { PhonePrefix, PanamaLayout },
})
export default class Profile extends ProfileProps {
  private showPinModal = false;

  private pin = "";
  private subjectId = "";
  private username = "";
  private givenName = "";
  private familyName = "";
  private email = "";
  private phone = "";
  private phonePrefix = "";
  private cedula = "";
  private passport = "";
  private picture = "";
  private address = "";
  private qrBase64 = "";
  private publicProfile = "";
  private externalInfo: string[] = [];
  private roles: string[] = [];

  private errorMessageShow = false;
  private errorMessage = "Error validando el <strong>PIN</strong>";
  $t: any;
  $router: any;

  selectedPrefix(prefix: string) {
    this.phonePrefix = prefix;
  }

  get profilePicture() {
    return `${Variables.ApiBaseUrl}/api/profile/photo/${this.picture}`;
  }

  get profileQr() {
    return `${Variables.ApiBaseUrl}/api/profile/qr/${this.subjectId}`;
  }

  get vaccinationHref() {
    return `${Variables.ApiBaseUrl}/api/profile/Vaccination`;
  }

  get qrBase64Src() {
    return `data:image/png;base64,${this.qrBase64}`;
  }

  get panamaDigitalPath() {
    return Variables.PanamaDigitalPath;
  }

  async vaccination(pin: string) {
    try {
      if (this.showPinModal && pin === "") {
        return;
      }
      window.location.href = await profileApi.vaccination(
        new VaccinationProfileQuery(this.subject, pin)
      );
    } catch (err) {      
      if (this.showPinModal) {
        if (err.response.status === 400) {
          let message = "<ul>";
          err.response.data.forEach((element: any) => {
            message += `<li>${this.$t(`errors.${element}`)}</li>`;
          });
          message += "</ul>";
          this.errorMessage = message;
          this.errorMessageShow = true;
        }
      }

      if (pin === "") {
        this.showPinModal = true;
      }
    }
  }

  async mounted() {
    try {
      const profile = await profileApi.profile(new ProfileQuery(this.subject));
      this.subjectId = profile.subject;
      this.username = profile.username;
      this.givenName = profile.givenName;
      this.familyName = profile.familyName;
      this.email = profile.email;
      this.phone = profile.phone;
      this.address = profile.address;
      this.cedula = profile.cedula;
      this.passport = profile.passport;
      this.picture = profile.profilePhoto;
      this.publicProfile = profile.publicProfileUrl;
      this.roles = [];
      profile.roles.forEach((r) => this.roles.push(r));
      this.externalInfo = [];
      profile.externalInfo.forEach((ei) => this.externalInfo.push(ei));
    } catch {
      await this.$router.push({ name: "Login" });
    }
  }
}
